// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPolicyLiteBalanceReminderDto
 */
export interface IPolicyLiteBalanceReminderDto {
    /**
     * 
     * @type {number}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    account_type?: IPolicyLiteBalanceReminderDtoAccountTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    is_carded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    include_to_balance_reminder?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    claim_submit_date_end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    plan_year_valid_to?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyLiteBalanceReminderDto
     */
    coverage_period_end?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IPolicyLiteBalanceReminderDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IPolicyLiteBalanceReminderDto interface.
 */
export function instanceOfIPolicyLiteBalanceReminderDto(value: object): value is IPolicyLiteBalanceReminderDto {
    return true;
}

export function IPolicyLiteBalanceReminderDtoFromJSON(json: any): IPolicyLiteBalanceReminderDto {
    return IPolicyLiteBalanceReminderDtoFromJSONTyped(json, false);
}

export function IPolicyLiteBalanceReminderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicyLiteBalanceReminderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['accountId'] == null ? undefined : json['accountId'],
        'plan_name': json['planName'] == null ? undefined : json['planName'],
        'account_type': json['accountType'] == null ? undefined : json['accountType'],
        'is_carded': json['isCarded'] == null ? undefined : json['isCarded'],
        'include_to_balance_reminder': json['includeToBalanceReminder'] == null ? undefined : json['includeToBalanceReminder'],
        'claim_submit_date_end': json['claimSubmitDateEnd'] == null ? undefined : (new Date(json['claimSubmitDateEnd'])),
        'plan_year_valid_to': json['planYearValidTo'] == null ? undefined : (new Date(json['planYearValidTo'])),
        'coverage_period_end': json['coveragePeriodEnd'] == null ? undefined : (new Date(json['coveragePeriodEnd'])),
    };
}

export function IPolicyLiteBalanceReminderDtoToJSON(json: any): IPolicyLiteBalanceReminderDto {
    return IPolicyLiteBalanceReminderDtoToJSONTyped(json, false);
}

export function IPolicyLiteBalanceReminderDtoToJSONTyped(value?: IPolicyLiteBalanceReminderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['account_id'],
        'planName': value['plan_name'],
        'accountType': value['account_type'],
        'isCarded': value['is_carded'],
        'includeToBalanceReminder': value['include_to_balance_reminder'],
        'claimSubmitDateEnd': value['claim_submit_date_end'] == null ? undefined : ((value['claim_submit_date_end']).toISOString().substring(0,10)),
        'planYearValidTo': value['plan_year_valid_to'] == null ? undefined : ((value['plan_year_valid_to']).toISOString().substring(0,10)),
        'coveragePeriodEnd': value['coverage_period_end'] == null ? undefined : ((value['coverage_period_end']).toISOString().substring(0,10)),
    };
}

